var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.value.Subject || '-'))]),_c('br'),_c('p',{staticClass:"card-text",domProps:{"innerHTML":_vm._s(_vm.value.Content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }